import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<Cart | undefined>;

export const DispatchUpdateCart: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Data/Carts/CompleteLoadCart",
        model: props.parameter,
        isCurrent: true,
        replaceCart: true,
    });
};

export const chain = [DispatchUpdateCart];

const updateCart = createHandlerChainRunnerOptionalParameter(chain, {} as Cart, "UpdateCart");
export default updateCart;
